<template>
  <div ref="chartContainer" style="width: 100%; height: 100%">
    <div v-if="renderGraph" style="width: 100%; height: 100%">
      <slot></slot>
      <apexchart
        ref="apexChartRef"
        :height="height"
        :width="`${chartWidth}px`"
        :options="options"
        :series="series"
      ></apexchart>
      <!-- <apexchart
        ref="apexChartRef"
        :height="height"
        :width="`200px`"
        :options="options"
        :series="series"
      ></apexchart> -->
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      height: String,
      options: Object,
      series: Array,
      resizeChecking: {
        type: Boolean,
        default: true,
      },
    },
    data: () => ({
      chartWidthDebounce: null,
      chartWidth: 300,
      renderGraph: false,
      checkRender: null,
    }),
    watch: {
      series: function () {
        console.log(this.series);
      },
    },
    methods: {
      handleResize() {
        this.renderGraph = false;
        if (this.resizeChecking == true) {
          clearTimeout(this.chartWidthDebounce);
          this.chartWidthDebounce = setTimeout(() => {
            this.chartWidth = this.$refs.chartContainer.clientWidth;
            this.renderGraph = true;
          }, 100);
        } else {
          this.chartWidth = this.$refs.chartContainer.clientWidth;
          this.renderGraph = true;
        }
      },
      zoom(min, max) {
        this.$refs.apexChartRef.zoomX(min == 0 ? 1 : min, max);
      },
      dataPointSelection(a) {
        this.$refs.apexChartRef.removeAnnotation("selected-x-annotation");
        this.$refs.apexChartRef.addXaxisAnnotation({
          id: "selected-x-annotation",
          x: a,
          borderColor: "black",
          strokeDashArray: 0,
        });
      },
      updateLowerUperLimits(limits) {
        setTimeout(() => {
          this.$refs.apexChartRef.removeAnnotation("lower");
          this.$refs.apexChartRef.removeAnnotation("mid");
          this.$refs.apexChartRef.removeAnnotation("upper");
          this.$refs.apexChartRef.addYaxisAnnotation({
            id: "lower",
            y: 0,
            y2: limits.lower,
            borderColor: "#000",
            fillColor: "#008000",
          });
          this.$refs.apexChartRef.addYaxisAnnotation({
            id: "mid",
            y: limits.lower,
            y2: limits.upper,
            borderColor: "#000",
            fillColor: "#eb9c34",
          });
          this.$refs.apexChartRef.addYaxisAnnotation({
            id: "upper",
            y: limits.upper,
            y2: 100,
            borderColor: "#000",
            fillColor: "#eb4034",
          });
        }, 100);
      },
      updateSeries(newSeries, animate) {
        this.$refs.apexChartRef.updateSeries(newSeries, animate);
        // console.log(newSeries, animate);
      },
    },
    beforeDestroy: function () {
      window.removeEventListener("resize", this.handleResize);
      clearInterval(this.checkRender);
    },
    mounted() {
      setTimeout(() => {
        this.handleResize();
        if (this.resizeChecking == true) {
          window.addEventListener("resize", this.handleResize);
          this.checkRender = setInterval(() => {
            if (this.chartWidth != this.$refs.chartContainer.clientWidth) {
              this.handleResize();
            }
          }, 500);
        }
      }, 10);
    },
  };
</script>
